import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROItemOptions = get('reservation.ROItemOptions');

export const getAll = createSelector(getROItemOptions, get('all'));
export const getIsFetching = createSelector(getROItemOptions, get('fetching'));
export const getIsFetched = createSelector(getROItemOptions, get('fetched'));

export const getFetchingError = createSelector(
  getROItemOptions,
  get('fetchingError')
);
